__webpack_require__.p = "https://live.asktek.net/ask_websites_manager_ui/";